import * as React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';

export default function GymRules() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        '& > :not(style)': {
          m: 1,
          width: '100%',
          height: '100vh',
        },
      }}
    
    >
      <Paper      
        elevation={3}
        
        >
            <img style={{ width: '100%' }} src="/assets/images/runway/usagerules.jpg" alt="" />

        </Paper>
    </Box>
  );
}